import React, { useRef, useState, useEffect } from "react"
import { PrimaryGalleryLeftImageRightHeadingTextType } from "../../types/mainModulTypes"
import { Navigation } from "swiper/modules"
import { Swiper as SwiperType } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/navigation"
import { API } from "../../constants/constants"
import BaseHeadline from "../common/BaseHeadline"
import BaseRichtext from "../common/BaseRichtext"

export default function PrimaryGalleryLeftImageRightHeadingText(props: PrimaryGalleryLeftImageRightHeadingTextType) {
    const swiperRef = useRef<SwiperType>()

    const [isBeginning, setIsBeginning] = useState(true)
    const [isEnd, setIsEnd] = useState(false)

    useEffect(() => {
        if (swiperRef.current) {
            setIsBeginning(swiperRef.current.isBeginning)
            setIsEnd(swiperRef.current.isEnd)
        }
    }, [])

    return (
        <div className="max-w-content mx-auto flex gap-4 justify-between relative items-center">
            <button
                onClick={() => {
                    swiperRef.current?.slidePrev()
                    setIsBeginning(swiperRef.current?.isBeginning ?? true)
                    setIsEnd(swiperRef.current?.isEnd ?? false)
                }}
                disabled={isBeginning}
                className={`w-0 h-0 border-t-[50px] border-t-transparent border-b-[50px] border-b-transparent border-l-[30px] 
                ${isBeginning ? "border-l-gray-400 cursor-not-allowed" : "border-l-base-300"} rotate-180`}
            />
            <Swiper
                slidesPerView={1}
                spaceBetween={50}
                modules={[Navigation]}
                onBeforeInit={(swiper: SwiperType) => {
                    swiperRef.current = swiper
                }}
                className="mySwiper  max-w-content mx-auto">
                {props?.primaryGalleryLeftImageRightHeadingTextGallery?.map((item, index) => (
                    <SwiperSlide key={index} className="relative w-full max-w-full">
                        <div className="flex gap-8 w-full max-w-3xl mx-auto">
                            <img
                                src={API + item?.primaryGalleryLeftImageRightHeadingTextGalleryItemImage?.url}
                                alt={API + item?.primaryGalleryLeftImageRightHeadingTextGalleryItemImage?.description}
                                className="w-5/12 aspect-[5/7] rounded-default object-cover"
                            />
                            <div className="w-6/12">
                                <BaseHeadline headlineType={4} label={item?.primaryGalleryLeftImageRightHeadingTextGalleryItemHeading} />
                                <BaseRichtext content={item?.primaryGalleryLeftImageRightHeadingTextGalleryItemText} />
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

            <button
                onClick={() => {
                    swiperRef.current?.slideNext()
                    setIsBeginning(swiperRef.current?.isBeginning ?? true)
                    setIsEnd(swiperRef.current?.isEnd ?? false)
                }}
                disabled={isEnd}
                className={`w-0 h-0 border-t-[50px] border-t-transparent border-b-[50px] border-b-transparent border-l-[30px] 
                ${isEnd ? "border-l-gray-400 cursor-not-allowed" : "border-l-base-300"}`}
            />
        </div>
    )
}
